import { withLabel } from "./editor-text";

export const SAMPLE_PAYLOAD_KEYS = {
  FAMILY: "FAMILY",
  COUPLE: "COUPLE",
  SINGLE: "SINGLE",
};

const PLAN_ID = "sample-insurance-plan";
const GENERATED_AT = "2026-10-16T09:00:00.000Z";

const telecom = (id, system, value) => ({ id, use: "HOME", system, value });

const MEMBER_USER = {
  id: "sample-member-user",
  firstname: "Camille",
  lastname: "Leroux",
  birthName: "Leroux",
  maritalName: null,
  birthDate: "1988-04-12T00:00:00.000Z",
  gender: "F",
  email: "camille.leroux@example.fr",
  phone: "0639980001",
};

const MEMBER_TELECOMS = [
  telecom("sample-telecom-email", "EMAIL", "camille.leroux@example.fr"),
  telecom("sample-telecom-phone", "PHONE", "0639980001"),
  telecom("sample-telecom-landline", "LANDLINE", "0199000001"),
  telecom("sample-telecom-address", "ADDRESS", "12 rue des Lilas"),
  telecom("sample-telecom-complement", "COMPLEMENT", "Bâtiment B"),
  telecom("sample-telecom-zip", "ZIP_CODE", "69003"),
  telecom("sample-telecom-city", "CITY", "Lyon"),
  telecom("sample-telecom-country", "COUNTRY", "France"),
  telecom("sample-telecom-birth-city", "BIRTH_CITY", "Annecy"),
  telecom("sample-telecom-birth-department", "DEPARTMENT_OF_BIRTH", "74"),
  telecom("sample-telecom-birth-country", "BIRTH_COUNTRY", "France"),
];

const relatedPerson = ({ id, relationship, identity }) => ({
  id,
  relationship,
  authority: "SELF",
  identity: {
    id: `${id}-contact`,
    fields: {},
    socialRegime: "SECURITE_SOCIALE",
    profession: null,
    telecoms: [],
    ...identity,
  },
});

const SPOUSE = relatedPerson({
  id: "sample-spouse",
  relationship: "SPOUSE",
  identity: {
    socialSecurityNumber: "186097500000017",
    profession: "Professeur des écoles",
    user: {
      id: "sample-spouse-user",
      firstname: "Julien",
      lastname: "Marchand",
      birthName: "Marchand",
      maritalName: null,
      birthDate: "1986-09-03T00:00:00.000Z",
      gender: "M",
    },
  },
});

const CHILDREN = [
  relatedPerson({
    id: "sample-child-lea",
    relationship: "CHILD",
    identity: {
      socialSecurityNumber: "215067500000031",
      user: {
        id: "sample-child-lea-user",
        firstname: "Léa",
        lastname: "Marchand",
        birthName: "Marchand",
        maritalName: null,
        birthDate: "2015-06-21T00:00:00.000Z",
        gender: "F",
      },
    },
  }),
  relatedPerson({
    id: "sample-child-hugo",
    relationship: "CHILD",
    identity: {
      socialSecurityNumber: "118027500000025",
      user: {
        id: "sample-child-hugo-user",
        firstname: "Hugo",
        lastname: "Marchand",
        birthName: "Marchand",
        maritalName: null,
        birthDate: "2018-02-14T00:00:00.000Z",
        gender: "M",
      },
    },
  }),
];

const ORGANIZATION = {
  id: "sample-organization",
  name: "Exemple Courtage",
  siretNumber: "00000000000018",
  icon: null,
  config: {},
  additionalInfo: {},
  broker: {
    id: "sample-broker",
    socialReason: "Exemple Courtage SAS",
    code: "EX-0001",
    orias: "00000000",
    isInternal: false,
    rcsNumber: "000 000 000",
    sirenNumber: "000000000",
    rcsPlace: "Lyon",
  },
};

const ADVISOR = {
  id: "sample-advisor",
  firstname: "Élise",
  lastname: "Fontaine",
  email: "elise.fontaine@example.fr",
  phone: "0639980010",
  meta: {},
  organization: ORGANIZATION,
  poles: [],
};

const INSURANCE_PLAN = {
  id: PLAN_ID,
  identifier: "SANTE-EX-3",
  name: "Santé Exemple Niveau 3",
  product: null,
  category: null,
  risk: "health",
  level: 3,
  alias: null,
  aliases: [],
  startDate: "2026-01-01T00:00:00.000Z",
  endDate: null,
  params: [],
};

const COSTS = {
  [SAMPLE_PAYLOAD_KEYS.FAMILY]: {
    adherentCost: 68.4,
    spouseCost: 61.2,
    childrenCost: 42.6,
  },
  [SAMPLE_PAYLOAD_KEYS.COUPLE]: {
    adherentCost: 68.4,
    spouseCost: 61.2,
    childrenCost: 0,
  },
  [SAMPLE_PAYLOAD_KEYS.SINGLE]: {
    adherentCost: 68.4,
    spouseCost: 0,
    childrenCost: 0,
  },
};

const FAMILY_SITUATIONS = {
  [SAMPLE_PAYLOAD_KEYS.FAMILY]: "MARRIED",
  [SAMPLE_PAYLOAD_KEYS.COUPLE]: "PACS",
  [SAMPLE_PAYLOAD_KEYS.SINGLE]: "SINGLE",
};

const RELATED_PERSONS = {
  [SAMPLE_PAYLOAD_KEYS.FAMILY]: [SPOUSE, ...CHILDREN],
  [SAMPLE_PAYLOAD_KEYS.COUPLE]: [SPOUSE],
  [SAMPLE_PAYLOAD_KEYS.SINGLE]: [],
};

const bankAccount = (id) => ({
  id,
  IBAN: "FR7612345000010000000000042",
  BIC: "EXMPFRPPXXX",
  owner: {
    id: `${id}-owner`,
    type: "PARTICULAR",
    gender: MEMBER_USER.gender,
    firstName: MEMBER_USER.firstname,
    lastName: MEMBER_USER.lastname,
    socialReason: null,
    isAdherent: true,
    telecoms: [],
  },
});

const buildSamplePayload = (key) => {
  const costDetails = COSTS[key];
  const cost = Number(
    (
      costDetails.adherentCost +
      costDetails.spouseCost +
      costDetails.childrenCost
    ).toFixed(2),
  );
  const generalCost = {
    id: `sample-general-cost-${key.toLowerCase()}`,
    cost,
    billingPeriod: "MONTHLY",
    tax: 0,
    administrativeFees: 10,
    currency: "EUR",
    recommended: true,
    costDetails,
    insurancePlan: INSURANCE_PLAN,
  };
  const project = {
    id: `sample-project-${key.toLowerCase()}`,
    name: null,
    ria: false,
    hasResponsible: false,
    projectType: null,
    fields: {
      selectedToCompare: [PLAN_ID],
      quoteValidity: "2026-11-15T00:00:00.000Z",
    },
    contact: {
      id: "sample-member-contact",
      ref: null,
      fields: {},
      socialRegime: "SECURITE_SOCIALE",
      socialSecurityNumber: "288047500000042",
      nationality: "FR",
      familySituation: FAMILY_SITUATIONS[key],
      socioProfessionalCategory: "EXECUTIVES",
      siretNumber: null,
      profession: "Architecte",
      optMadelin: false,
      acceptContact: true,
      acceptDigital: true,
      politicallyExposedPerson: false,
      user: MEMBER_USER,
      telecoms: MEMBER_TELECOMS,
      relatedPersons: RELATED_PERSONS[key],
    },
    contract: {
      id: "sample-contract",
      issuanceDate: "2026-11-01T00:00:00.000Z",
    },
    terminationRequest: null,
    author: ADVISOR,
    ownedBy: { id: ORGANIZATION.id, name: ORGANIZATION.name },
    statuses: [],
  };
  return {
    meta: {
      version: 2,
      generatedAt: GENERATED_AT,
      currentDate: "16/10/2026",
      currentInsurancePlanId: PLAN_ID,
    },
    subscription: {
      id: `sample-subscription-${key.toLowerCase()}`,
      number: 1042,
      status: "DRAFT",
      issuanceDate: "2026-10-16T09:30:00.000Z",
      signedDate: "2026-10-16T09:30:00.000Z",
      additionalInfo: {},
      project,
      insurancePlan: INSURANCE_PLAN,
      payment: {
        id: "sample-payment",
        type: "DEBIT",
        frequency: "MONTHLY",
        debitDay: "5",
        payer: bankAccount("sample-payer-account"),
        receiver: bankAccount("sample-receiver-account"),
      },
      attachments: [],
    },
    project,
    insurancePlan: INSURANCE_PLAN,
    generalCost,
    generalCosts: [generalCost],
    advisor: ADVISOR,
    user: ADVISOR,
    organization: ORGANIZATION,
    needPhrases: {},
    quoteNumber: 1042,
  };
};

export const SAMPLE_PAYLOADS = Object.values(SAMPLE_PAYLOAD_KEYS).map((key) =>
  withLabel({ key, payload: buildSamplePayload(key) }, `SAMPLES.${key}`),
);

export const DEFAULT_SAMPLE_PAYLOAD_KEY = SAMPLE_PAYLOAD_KEYS.FAMILY;

export const findSamplePayload = (key) =>
  SAMPLE_PAYLOADS.find((sample) => sample.key === key) || SAMPLE_PAYLOADS[0];
